export default "__VITE_ASSET__DjFOwP5b__"